// routes.js
import { Suspense } from "react";
import ClientLayout from "../layouts/ClientLayout";
import LoadingSpinner from "../components/LoadingSpinner";
import Index from "../Pages/Index";
import ReservationPage from "../Pages/ReservationPage";
// const ProductPage = lazy(() => import("../Pages/ProductPage"));
import LoginPage from "./../Pages/auth/LoginPage";
import RegisterPage from "../Pages/auth/RegisterPage";
import RegisterVerificationPage from "../Pages/auth/RegisterVerification";
import AccountNotActivated from "../Pages/auth/AccountNotActivated";
import ResetPasswordPage from "../Pages/auth/ResetPassword";
import ServicePage from "../Pages/ServicePage";
import PublicSubscriptionsPage from "../Pages/PublicSubscriptionsPage";
import ProfilePage from "../Pages/ProfilePage";
import ProtectedRoute from "../components/ProtectedRoute";
import ReservationUserPage from "../Pages/ReservationUser";
import CartPage from "../Pages/CartPage";
import AdminLayout from "../layouts/AdminLayout";
import { Navigate } from "react-router-dom";
import ForgotPasswordPage from "../Pages/auth/ForgotPassword";
import Dashboard from "../Pages/admin/Dashboard";
import WorkersPage from "../Pages/admin/WorkersPage";
import ServicesPage from "../Pages/admin/ServicesPage";
import FournisseursPage from "../Pages/admin/FournisseursPage";
import StockCommandePage from "../Pages/admin/StockCommandePage";
import SubscriptionsCataloguePage from "../Pages/admin/SubscriptionsCataloguePage";
import ClientsPage from "../Pages/admin/ClientsPage";
import PaiementsPage from "../Pages/admin/PaiementsPage";
import SalesPage from "../Pages/admin/SalesPage";
import RendezVousPage from "../Pages/admin/RendezVousPage";
import SalesDayPage from "../Pages/admin/SalesDayPage";
import SalesSubscriptionsPage from "../Pages/admin/SalesSubscriptionsPage";
import CataloguePage from "../Pages/admin/CataloguePage";
import InventairesPage from "../Pages/admin/InventairesPage";
import TeamsPage from "../Pages/admin/TeamsPage";
import TeamsRolePage from "../Pages/admin/TeamsRolePage";
import SalonPage from "../Pages/admin/SalonPage";
import FonctionnalitesPage from "../Pages/admin/FonctionnalitesPage";
import SubscriptionsPage from "../Pages/admin/SubscriptionsPage";
import CreateSubscriptionPage from "../Pages/admin/CreateSubscriptionPage";
import EditSubscriptionPage from "../Pages/admin/EditSubscriptionPage";
import DetailsSubscriptionPage from "../Pages/admin/DetailsSubscriptionPage";
import PurchasesPage from "../Pages/PurchasesPage";
import UserSubscriptionsPage from "../Pages/UserSubscriptionsPage";
import GiftCardsPage from "../Pages/admin/GiftCardsPage";
import ProductsPage from "../Pages/admin/ProductsPage";
import RapportsPage from "../Pages/admin/RapportPage";
import AutomatisationsPage from "../Pages/admin/AutomatisationsPage";

export const adminRoutes = [
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { path: "", element: <Navigate to="dashboard" /> },
      { path: "*", element: <Dashboard /> },
      { path: "dashboard", element: <Dashboard /> },

      // Ouvriers
      { path: "workers", element: <WorkersPage /> },

      // Ventes
      { path: "sales-day", element: <SalesDayPage /> },
      { path: "rendez-vous", element: <RendezVousPage /> },

      { path: "sales", element: <SalesPage /> },
      { path: "paiements", element: <PaiementsPage /> },
      { path: "gift-cards", element: <GiftCardsPage /> },
      { path: "sales-suscribtions", element: <SalesSubscriptionsPage /> },

      // Clients
      { path: "custumers", element: <ClientsPage /> },

      // Catalogue
      { path: "catalogue", element: <CataloguePage /> },
      {
        path: "suscribtions-catalogue",
        element: <SubscriptionsCataloguePage />,
      },
      {
        path: "subscriptions",
        element: <SubscriptionsPage />,
      },
      {
        path: "subscriptions/:id",
        element: <DetailsSubscriptionPage />,
      },

      {
        path: "subscriptions/create",
        element: <CreateSubscriptionPage />,
      },
      {
        path: "subscriptions/:id/edit",
        element: <EditSubscriptionPage />,
      },

      { path: "products", element: <ProductsPage /> },
      { path: "inventaires", element: <InventairesPage /> },
      { path: "stock-commande", element: <StockCommandePage /> },
      { path: "fournisseurs", element: <FournisseursPage /> },

      // Équipe
      {
        path: "teams",
        element: <TeamsPage />,
      },
      {
        path: "team/:idRole",
        element: <TeamsRolePage />,
      },

      // { path: "employee", element: <EmployeePage /> },
      // { path: "admins", element: <AdminsPage /> },

      // Services
      { path: "services", element: <ServicesPage /> },

      // Rapports
      { path: "rapport", element: <RapportsPage /> },

      // Modules
      { path: "fonctionnalite", element: <FonctionnalitesPage /> },
      { path: "automatisations", element: <AutomatisationsPage /> },

      // Paramètres
      { path: "salon", element: <SalonPage /> },
    ],
  },
];

export const publicRoutes = [
  { path: "/login", element: <LoginPage /> },
  { path: "/login/:callback", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/register/:callback", element: <RegisterPage /> },
  {
    path: "/register-2/:callback",
    element: <RegisterVerificationPage />,
  },
  {
    path: "/account-not-activated",
    element: <AccountNotActivated />,
  },
  {
    path: "/account-not-activated/:callback",
    element: <AccountNotActivated />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/forgot-password/:callback",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/reset-password/:callback",
    element: <ResetPasswordPage />,
  },
  {
    path: "*",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <Index />
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <Index />
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/services",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <ReservationPage />
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/service/:service_id",
    element: (
      <ClientLayout detail={true}>
        <Suspense fallback={<LoadingSpinner />}>
          <ServicePage />
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/plan-abonnements",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <PublicSubscriptionsPage />
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/cart",
    element: (
      <ClientLayout detail={true}>
        <Suspense fallback={<LoadingSpinner />}>
          <CartPage />
        </Suspense>
      </ClientLayout>
    ),
  },
];

export const secureRoutes = [
  {
    path: "/profil",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/rendez-vous",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <ProtectedRoute>
            <ReservationUserPage />
          </ProtectedRoute>
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/mes-achats",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <ProtectedRoute>
            <PurchasesPage />
          </ProtectedRoute>
        </Suspense>
      </ClientLayout>
    ),
  },
  {
    path: "/mes-abonnements",
    element: (
      <ClientLayout>
        <Suspense fallback={<LoadingSpinner />}>
          <ProtectedRoute>
            <UserSubscriptionsPage />
          </ProtectedRoute>
        </Suspense>
      </ClientLayout>
    ),
  },
];
